import Typography from 'components/CncUI/Typography';

import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    alignItems: 'center',
  },
  content: {
    textAlign: 'left',
    padding: '0 !important',
  },
  title: {
    color: `${palette.cncUI.misc.link} !important`,
    textDecoration: 'none',
    textTransform: 'none',
    fontSize: 12,
  },
}));

const StoreCard = props => {
  const classes = useStyles();
  const { data } = props;
  return (
    <Card
      key={data.dataTestId}
      className={classes.root}
      id={data.id}
      style={{ paddingTop: data.padding }}
    >
      <CardMedia
        style={{
          height: data.image.height,
          width: data.image.width,
        }}
        image={data.image.source}
      />
      <CardContent className={classes.content}>
        <Typography variant="body2" className={classes.title}>
          {data.label}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StoreCard;
